<template>
  <div class="banner">
    <div class="banner-img" v-if="!isMobile">
      <div class="img-wrap" :style="{'background-image': `url(${bannerInfo.banner})`}"></div>
    </div>
    <div class="banner-img mobile-banner-img" v-else>
      <img :src="bannerInfo.banner_mb" alt="">
    </div>
    <div class="apply-card" ref="applyBtn">
      <div class="card-message">
        <div class="card-title">{{bannerInfo.title}}</div>
        <div class="card-time">
          <img src="../../assets/img/form/time.png" alt="">
          <span v-if="info.start_time > 0">
            {{start_time}} - {{end_time}}
          </span>
        </div>
        <div class="card-location" v-if="bannerInfo.type === 1 && bannerInfo.address">
          <img src="../../assets/img/form/location.png" alt="">
          <span>{{bannerInfo.address}}</span>
        </div>
        <div class="card-remark" v-if="bannerInfo.remark" v-html="bannerInfo.remark"></div>
      </div>
      <template v-if="bannerInfo.start_time">
        <!-- 活动已结束 -->
        <template v-if="eventStatu === 'end'">
          <div class="apply-btn" :class="isMobile ? 'apply-btn-mobile' : ''">
            <gkButton color="blue"
              :disabled="true" 
              :size="isMobile ? 'height60' : 'height48'"
              v-if="bannerInfo.link_type !== 1"
            >
              {{btnLabel}}
            </gkButton>
          </div>
        </template>
        <!-- 活动未结束 -->
        <template v-else>
          <div class="apply-btn" :class="isMobile ? 'apply-btn-mobile' : ''" v-if="bannerInfo.link_type === 0">
            <gkButton 
              data-sensors-click
              @click="handleClick" 
              color="blue"
              :size="isMobile ? 'height60' : 'height48'"
            >
              {{btnLabel}}
            </gkButton>
          </div>
          <div class="apply-btn" v-if="bannerInfo.link_type === 2">
            <div v-if="!isMobile" class="wx-qrcode">
              <img :src="bannerInfo.link.link" alt="">
              <div class="desc">{{btnLabel}}</div>
            </div>
            <gkButton v-else @click="openQrcode" color="blue" 
              size="height38"
              style="margin-top: 20px"
            >
              {{btnLabel}}
            </gkButton>
          </div>
          <com-floating-win ref="qrcode" class="display-mobile"
            v-show="isMobile && bannerInfo.link_type === 2"
            :isShowCircle="showCode"
            :code="bannerInfo.link.link"
            :desc="btnLabel"
          ></com-floating-win>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import gkButton from 'gkui/button'
import ComFloatingWin from './module/com-floating-win'

import moment from 'moment'
import 'moment/locale/zh-cn'

import utils from '../../utils'

export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    eventStatu: {
      type: String,
      default: 'null'
    },
    btnLabel: {
      type: String,
      default: ''
    },
    showCode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      aid: Number(this.$route.query.id),
      bannerInfo: {},
      start_time: '',
      end_time: ''
    }
  },
  components: {
    gkButton,
    ComFloatingWin
  },
  watch: {
    info (newInfo) {
      this.bannerInfo = newInfo
      let start = new Date(this.info.start_time * 1000)
      let end = new Date(this.info.end_time * 1000)
      if (+this.bannerInfo.time_style === 2) {
        moment.locale('en')
        this.start_time = moment(start).format('MMM Do YYYY, HH:mm')
        this.end_time = moment(end).format('MMM Do YYYY, HH:mm')
      } else {
        this.start_time = moment(start).format('YYYY 年 MM 月 DD 日 HH:mm')
        this.end_time = moment(end).format('YYYY 年 MM 月 DD 日 HH:mm')
      }
    }
  },
  computed: {
    ...mapState([
      'isMobile',
      'loginUser'
    ])
  },
  methods: {
    handleClick () {
      if (this.info.login_type && !this.loginUser) {
        let params = {
          cb: this.enter
        }
        utils.login(params)
        this.$Message.toast({
          message: '登录后才可报名活动'
        })
        utils.storage.set('loginAction', {
          options: this.enter
        })
        return
      }
      // if (this.eventStatu === 'wait') return
      let gaButtonStatus = this.btnLabel
      window.ga && window.ga('send', 'event', '活动管理按钮点击数', `${this.aid} - ${this.isMobile ? 'mobile' : 'pc'}`, gaButtonStatus)
      // TODO 表单跳转
      this.enter()
    },
    enter () {
      window.open(this.bannerInfo.link.link)
    },
    openQrcode () {
      this.$refs.qrcode.closeCloak()
    }
  }
}
</script>
<style lang="scss">
@import "../../assets/css/_common";

.banner {
  position: relative;

  & .banner-img {
    position: relative;
    width: 100%; height: 500px;
    overflow: hidden;

    & .img-wrap {
      height: 100%;
      background-position: center center;
      background-size: cover;
    }
  }

  & .mobile-banner-img {
    width: 100%; height: 215px;
    overflow: hidden;
    
    img {
      display: block;
      width: 100%;
    }
  }

  & .apply-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    z-index: 200;
    margin: -52px auto 33px;
    width: 1160px;
    padding: 36px 63px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 3px 14px 0px rgba(221,221,221,0.59);

    & .card-message {
      width: 688px;
      margin-right: 143px;
      color: $lightBlack;

      & .card-title {
        margin-bottom: 16px;
        @include font(28, 600);
        line-height: 36px;
        // @include row(2);
      }

      & .card-time, & .card-location {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        @include lineFont(16, 400);
        color: $bodyBlack;
        
        & img {
          margin-right: 8px;
          height: 15px;
        }
        // & .iconfont {
        //   margin-right: 8px;
        //   color: $blue;
        //   line-height: 16px;
        //   @include font(15, 500);
        // }
      }
      
      & .card-location {
        margin-bottom: 16px;
      }

      & .card-remark {
        @include font(14, 400);
        line-height: 21px;
        color: $gray;
        @include row(2);
      }
    }

    & .apply-btn {
      flex: none;
      width: 178px;

      & .wx-qrcode {
        margin: 0 auto;
        width: 107px;

        & img {
          width: 100%;
          height: 107px;
        }

        & .desc {
          letter-spacing: 3px;
          text-align: center;
          height: 14px;
          @include lineFont(14, 400);
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .banner {

    & .apply-card {
      align-items: flex-start;
      flex-direction: column;
      width: calc(100vw - 40px);
      padding: 22px 20px 24px;
      margin: -20px auto 28px;
      border-radius: 4px;

      & .card-message {
        width: auto;
        margin-right: 0;

        & .card-title {
          margin-bottom: 7px;
          @include font(21, 600);
          line-height: 30px;
        }

        & .card-time, & .card-location {
          align-items: normal;
          margin-bottom: 4px;
          line-height: 18px;
          @include font(12, 400);

          & img {
            margin-top: 2px;
            margin-right: 8px;
            height: 12px;
          }
          // & .iconfont {
          //   margin-right: 8px;
          //   line-height: 18px;
          //   @include font(12, 400);
          // }
        }

        & .card-remark {
          margin-top: 10px;
          text-align: justify;
          line-height: 18px;
          @include font(12, 400);
          @include row(3);
        }
      }

      & .apply-btn {
        margin: 0 auto;

        & .wx-qrcode {
          width: 137px;
          margin-top: 17px;
          img {
            height: 137px;
          }
        }
      }
    }

    & .apply-btn-mobile {
      position: fixed; bottom: 0; left: 0;
      width: 100vw !important;
      z-index: 999;
    }
  }
}
</style>
